module.exports = __webpack_public_path__ + "media/images/landing/illust/bg-hero-v2-50deaa5f83ed77541c67149281ad3669.svg";